import lessonApi from 'Api/axios/lesson-api';
import { useEffect, useState } from 'react';
import { LessonQuestionI } from 'types';

interface Props {
  init?: boolean;
  lessonId: string;
}

const useLessonQuestions = ({ lessonId, init = false }: Props) => {
  const [data, setData] = useState<Array<LessonQuestionI>>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getQuestions = async (lessonId: string) => {
    setLoading(true);
    const response = await lessonApi.getLessonQuestions(lessonId);
    setLoading(false);
    setData(response.data || []);
    setError(response.error);
  };

  useEffect(() => {
    if (init === true) {
      getQuestions(lessonId);
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    getQuestions,
  };
};

export default useLessonQuestions;
